var sleep = function sleep(ms) {
  return new Promise(function (resolve) {
    return setTimeout(resolve, ms);
  });
};

export var createDriver = function createDriver(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      _ref$timeout = _ref.timeout,
      timeout = _ref$timeout === void 0 ? 0 : _ref$timeout;

  return function (requestConfig) {
    return sleep(timeout).then(function () {
      if (requestConfig.response) {
        return requestConfig.response;
      }

      throw requestConfig.error;
    });
  };
};